<template>
  <div class="cook">
      <appHeader activeIndex="cook" ></appHeader>
      <img class="banner" src="../../assets/img/products/cook/banner.png" alt />
      <div class="cookContent">
        <!-- 介绍 -->
        <div class="cookInfo">
          <div class="cookInfo1">
            <img class="cookInfo1Img1" src="../../assets/img/Product/cook.png"  alt />
            <p class="productTitle">烹饪大师</p>
          </div>
          <el-divider></el-divider>
          <div class="cookInfo2">
             
             <h4>烹饪大师：在家不会做饭怎么办？超全菜谱手把手教你学会！</h4>
             <p>——精选菜谱倾情推荐：
创意菜、糕点烘焙、可口面食、网红快手菜、瘦身套餐、下午茶等等热门菜谱，各大菜谱下面又有超多分类，让你跟着教程慢慢学，一步一步的学会如何做菜！</p>
             <p>——分类齐全各式各样：
超过30种菜谱分类，每个分类中包含各种菜式，每个菜式中又囊括了数十种以上的菜品，每个菜品都包含超级详细的图文分析，根据图片和介绍来学习，肯定能做出好吃的菜肴！</p>
             <p>——实时更新流行菜谱：
每道菜都是根据大家喜欢的菜品选择出来，精心研究，我们会为您更新大家喜闻乐见的菜品，比如：快手菜，该菜品就是来自点赞超高的视频哦！</p>
             <p>——收藏转发推荐好友：
把喜欢的菜品和菜谱推荐给你的朋友和家人吧，同时也可以收藏到菜单中，下次大显身手的时候，就可以直接查看菜谱啦！</p>
             <p>——菜谱搜索超多答案：
直接在搜索框查找自己想要做的菜谱吧，比如搜索：蚂蚁上树，就会有超多菜谱哦，选择一个自己喜欢的做菜方式来使用吧！人性化设计让你随时使用都方便！</p>
          </div>
        </div>
        <!-- 第二部分内容 -->
        <el-divider></el-divider>
        <div class="cookCarousel">
          <div class="iconLeft" @click="left"><el-button icon="el-icon-arrow-left" circle></el-button></div>
          <div class="iconRight" @click="right"><el-button icon="el-icon-arrow-right" circle></el-button></div>
          <div class="cookWrap">
            <img class="cookCarouselImg" :style="{ 'margin-left': nowLeft + '%' }"  src="../../assets/img/products/cook/carousel.png" alt />
          </div>
          
        </div>
      </div>
    <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  mounted() {},
  methods: {
    
      left() {
        
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +21.5
      },

      right() {
        if(this.nowLeft <= -43){
          return;
        }
        this.nowLeft = this.nowLeft -21.5
      }
  }
};
</script>
<style>
@import "../../assets/css/products/cook.css";
</style>
